@if (column(); as column) {
  @if (model(); as model) {
    @switch (column.key) {
      @case (getColumnKey('featuredFileUrl')) {
        @if (isNotNil(model.featuredFileUrl)) {
          <app-image-thumbnail>
            <img
              [ngSrc]="model.featuredFileUrl"
              [fill]="true"
              [alt]="model.featuredFileAlt"
              class="object-contain" />
          </app-image-thumbnail>
        } @else {
          <app-image-thumbnail-unsupported />
        }
      }

      @case (getColumnKey('status')) {
        @if (isNotNil(model.status)) {
          <app-admin-box-status [status]="model.status" />
        } @else {
          <app-no-data />
        }
      }

      @case (getColumnKey('shopPreviewUrl')) {
        @if (isNotNil(model.shopPreviewUrl)) {
          <app-admin-box-link
            [slug]="model.slug"
            [status]="model.status" />
        } @else {
          <app-no-data />
        }
      }

      @case (getColumnKey('availableQuantity')) {
        @if (isNotNil(model.availableQuantity)) {
          {{ model.availableQuantity }}
        } @else {
          <app-no-data />
        }
      }

      @default {
        <app-table-body-no-reference-cell [columnKey]="column.key" />
      }
    }
  }
}
